export enum TnxLoadEventType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  CANCELED = 'CANCELED',
  AWARDED = 'AWARDED',
}
